import { AppLanguage, IUfinetSelectOption } from 'ufinet-web-functions'

export class NotificationLanguage {
	notificationLanguageId: string
	nameEs: string
	nameEn: string
	namePt: string

	constructor(id: string, nameEs: string, nameEn: string, namePt: string) {
		this.notificationLanguageId = id
		this.nameEs = nameEs
		this.nameEn = nameEn
		this.namePt = namePt
	}

	static mapNotificationLanguageToSelectOption(self: NotificationLanguage, language: AppLanguage): IUfinetSelectOption {
		return {
			label: language === 'es' ? self.nameEs : language === 'en' ? self.nameEn : self.namePt,
			value: self.notificationLanguageId,
		}
	}
}
